import axios from "axios";
import { Component } from "react";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";
import AuthBloc from "../bloc/auth_bloc";
import GeneralBloc from "../bloc/general_bloc";

class AuthWebService extends Component {
  //verifyOtpSession
  static async verifyOtpSession(userId,userType) {
    let dataEncry=await BaseWebService.getRequestId();
    let header = {
      RequestId:dataEncry[1],
      Uuid:dataEncry[0]  
    };          
    header.userType=userType;
   
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/${userType=="CUSTOMER" ? "client" :"auth"}/verifyOtpSession?userId=${userId}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async verifyEmailOtp(payload) {
    let header = await BaseWebService.tmpHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/session/verifyEmailOtp`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp);
    return response;
  }

  //verifySmsOtp
  static async verifySmsOtp(payload,type) {
    let header = await BaseWebService.tmpHeaders(type);
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/otp/verify`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp);
    return response;
  }
  
  //createEmailOtp
 /* static async createEmailOtp(payload,isResend,type) {
    let header = await BaseWebService.tmpHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/session/createEmailOtp?isResend=${isResend}&type=${type}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );    
    let response = BaseWebService.baseResponseFromWeb(resp);
    return response;
  }
   */
  //createSmsOtp
  static async createSmsOtp(payload,isResend,type) {
    let header = await BaseWebService.tmpHeaders(type);
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/otp/sms`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );    
    let response = BaseWebService.baseResponseFromWeb(resp);
    return response;
  }
  
  //resendSmsOtp
  static async resendSmsOtp(payload,isResend,type) {
    let header = await BaseWebService.tmpHeaders(type);
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/otp/resend`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );    
    let response = BaseWebService.baseResponseFromWeb(resp);
    return response;
  }

  //createEmailOtp
  static async createEmailOtp(payload,isResend,type) {
    let header = await BaseWebService.tmpHeaders(type);
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/otp/email`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );    
    let response = BaseWebService.baseResponseFromWeb(resp);
    return response;
  }

 
  static async resendEmailOtp(payload,isResend,type) {
    let header = await BaseWebService.tmpHeaders(type);
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/otp/resend`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );    
    let response = BaseWebService.baseResponseFromWeb(resp);
    return response;
  }
  

  //getAccesibleModules
  static async getAccesibleModules() {
    let header = await BaseWebService.tmpHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/module/accessibleModule`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );    
    let response = BaseWebService.baseResponseFromWeb(resp);

    return response;
  }
  
  //login
  static async login(payload) {   
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_AUTH}/login`); 
    let dataEncry=await BaseWebService.getRequestId();     
    let resp = await axios.post(
      url,
      payload,
      {
        headers: {
             "Content-Type": "application/json",              
              Accept: "*/*",   
        },
      }
    );
    let response = BaseWebService.baseResponseAuthFromWeb(resp.data);
    return response;
  }

  //loginClient
  static async loginClient(idNo, proposalId,clientType) {  
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/login`);  
    let dataEncry=await BaseWebService.getRequestId(); 
    let resp = await axios.post(
      url,
      {
        idNo: idNo,
        proposalId: proposalId,
        clientType:clientType                       
      },
      {
        headers: {
          RequestId:dataEncry[1],
          Uuid:dataEncry[0] 
        },
      }
    );
    let response = BaseWebService.baseResponseAuthFromWeb(resp.data);
    return response;
  }

  

  //onVerifyActiveSession
  static async onVerifyActiveSession(username) {  
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/auth/verifyActiveSession?userId=${username}`);  
    let dataEncry=await BaseWebService.getRequestId();    
    let resp = await axios.post(
      url,
      {        
      },
      {
        headers: {
          RequestId:dataEncry[1],
          Uuid:dataEncry[0] 
        },
      }
    );
    let response = BaseWebService.baseResponseAuthFromWeb(resp.data);
    return response;
  }

  //onVerifyValidClientSession
  static async onVerifyValidClientSession(proposalId,checkOnly) {  
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/checkValidSession?id=${proposalId}`);
    if(checkOnly){
      url=url+"&checkOnly="+checkOnly;
    }    
    let dataEncry=await BaseWebService.getRequestId();
    let resp = await axios.get(
      url,      
      {
        headers: {
          RequestId:dataEncry[1],
          Uuid:dataEncry[0] 
        },
      }
    );
    let response = BaseWebService.baseResponseAuthFromWeb(resp.data);
    return response;
  }

  //onRevokeLogout
  static async onRevokeLogout(username) {
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/auth/revokeActiveSession?userId=${username}`);    
    let dataEncry=await BaseWebService.getRequestId();
    let resp = await axios.post(
      url,
      {        
      },
      {
        headers: {
          RequestId:dataEncry[1],
          Uuid:dataEncry[0] 
        },
      }
    );
    let response = BaseWebService.baseResponseAuthFromWeb(resp.data);
    return response;
  }

  //resetPassword (no use)
  static async resetPassword(userName, password) {
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/localAuth/resetPassword`);
    let resp = await axios.post(
      url,
      {
        userName: userName,
        passwordAnswer: password,
      }
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //changePassword no use
  static async changePassword(userName, oldPassword, password) {
    let headers = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/localAuth/changePassword`);
    let resp = await axios.post(
      url,
      {
        oldPassword: oldPassword,
        newPassword: password,
        userName: userName,
      },
      { headers: headers }
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //logOutPortal
  static async logOutPortal(certId) {
    let headers = await BaseWebService.standardHeaders();    
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/auth/logout?certId=${certId}`);
    let resp = await axios.post(
      url,
      {
        payload:{}
      },
      { headers: headers }
    );    
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //renewToken
  static async renewToken(payload) {
    let headers = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/token/renew`);
    let resp = await axios.post(
      url,
      payload,
      { headers: headers }
    );
    let response = BaseWebService.baseResponseAuthFromWeb(resp);
    return response;
  }

  //verifyToken
  static async verifyToken() {
    let headers = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/token/verify`);
    let resp = await axios.post(
      url,
      {
        "payload": {}
      },
      { headers: headers }
    );
    let response = BaseWebService.baseResponseAuthFromWeb(resp);
    return response;
  }

}

export default AuthWebService;
